import { render } from "./ResponsiveLayout.vue?vue&type=template&id=3a47a3cc&scoped=true"
import script from "./ResponsiveLayout.vue?vue&type=script&lang=ts"
export * from "./ResponsiveLayout.vue?vue&type=script&lang=ts"

import "./ResponsiveLayout.vue?vue&type=style&index=0&id=3a47a3cc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3a47a3cc"

export default script